import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { changeOzonMarket } from '../../../actions/ozon';
import MarketCommonApi from '../../../API/market/common-api';
import MarketOzonApi from '../../../API/market/ozon-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, CheckButton, SendButton } from '../../../components/Basic/Buttons';
import { Link } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { Input, Select } from '../../../components/Basic/Inputs';
import { Text, TextGrey } from '../../../components/Basic/WrapsStyle';
import MarketProvidersDateUpdate from '../../../components/Markets/Blocks/MarketProvidersDateUpdate';
import { MARKETS_MAP, OZON_1, OZON_2, OZON_3, OZON_4, OZON_5, OZON_6, OZON_7, TYPE_BUTTONS } from '../../../constans';
import styles from './styles.module.scss';
import OzonTable from './Table';

const OzonPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const shop = useSelector((store) => store.ozon.market);
  const [isExpress, setIsExpress] = useState(false);
  const [isFbsRemainsMode, setIsFbsRemainsMode] = useState(location.pathname === '/fbo/fbsozon')
  const [marketInfo, setMarketInfo] = useState({});
  const [update, setUpdate] = useState(false)

  const [provider, changeProvider] = useState();
  const [providers, setProviders] = useState([]);
  const [providerData, setProviderData] = useState({});

  const allProviders = useSelector((store) => store.providers);
  const user = useSelector((store) => store.user);

  useEffect(() => { }, [update])


  const loadData = async (onlyNew = false) => {
    await MarketOzonApi.loadCards({ data: { shop: MARKETS_MAP[shop], onlyNew } })
  };

  const updateProviderStocksAndPrice = async (providerId = undefined, isNullStock = false, offerIds = undefined) => {
    return await MarketOzonApi.updateStocksAndPrices(
      {
        data: {
          shop: MARKETS_MAP[shop],
          filter: {
            providerId,
            offerIds,
            onlyProvider: true,
          },
          rules: {
            nullProvider: isNullStock,
            nullWarehouse: isNullStock,
          },
          skladName: 'msk'
        }
      }
    );
  };
  const updateProviderPrice = async (providerId = undefined, offerIds = undefined, ignoreDiffPrice = undefined, isFbsRemainsMode = undefined) => {
    return await MarketOzonApi.updateStocksAndPrices(
      {
        data: {
          shop: MARKETS_MAP[shop],
          filter: {
            providerId,
            offerIds,
            ...(isFbsRemainsMode && { onlyActiveFbsProducts: true })
          },
          rules: {
            onlyPrices: true,
            ignoreDiffPrice,
          },
          skladName: 'msk'
        },
      }
    );
  };

  const updateExpressStocks = async (skladName, isNullStock = false) => {
    return await MarketOzonApi.updateStocksAndPrices(
      {
        data: {
          shop: MARKETS_MAP[shop],
          filter: {
            onlyExpress: true,
            onlyProvider: false,
          },
          rules: {
            nullExpress: isNullStock,
          },
          skladName,
        }
      }
    );
  };

  const updateWarehouseStocks = async (isNullStock = false) => {
    await MarketOzonApi.updateStocksAndPrices(
      {
        data: {
          shop: MARKETS_MAP[shop],
          filter: {
            onlyWarehouse: true,
          },
          rules: {
            nullWarehouse: isNullStock,
          }
        }
      }
    );
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item['hide']);
    if (p.length > 0) {
      setProviders(p);
      changeProvider(p[0] || {});
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);


  useEffect(() => {
    MarketCommonApi.getMarketInfo({ data: { market: 'ozon' } }).then((r) => setMarketInfo(r.marketInfo));
  }, [])

  useEffect(() => {
    if (provider) {
      setProviderData(provider.markets_update[MARKETS_MAP[shop]]);
    }
  }, [provider, shop]);
  //
  const isOwner = user.role === 'owner' || user.role === 'admin';

  useEffect(() => {
    if (shop !== OZON_2) {
      setIsExpress(false);
    }
  }, [shop]);

  return (
    <>
      <Content>
        <Row style={{ alignItems: 'flex-start' }}>
          <WhiteBlock
            title="Управление"
            title_bold={`Ozon ${shop}`}
            // style={{ margin: '10px 0', minWidth: '350px' }}
            style={{ marginRight: '30px' }}
            minimize={!isFbsRemainsMode}
          >
            <Row style={{ alignItems: 'stretch' }}>
              <Column style={{ marginRight: '20px' }}>
                {/* <Row> */}
                <Column style={{ width: 'auto' }}>
                  <Select
                    style={{ marginBottom: '20px' }}
                    label="Магазин"
                    select={shop}
                    width={'200px'}
                    list={[OZON_1, OZON_2, OZON_3, OZON_4, OZON_5, OZON_6, OZON_7]}
                    onSelect={(v) => dispatch(changeOzonMarket(v))}
                  />
                </Column>
                {isFbsRemainsMode &&
                  <Column>
                    <Row>
                      <SendButton
                        sendData={{ data: { shop: MARKETS_MAP[shop] } }}
                        sendApi={MarketOzonApi.uploadStocksAndPrices}
                        style={{ marginRight: '15px' }}
                        endLoad={() => setUpdate(!update)}
                      >
                        Подгрузить остатки
                      </SendButton>
                      <Button
                        type={TYPE_BUTTONS.WHITE}
                        onClick={() => {
                          MarketOzonApi.excelStocksAndPricesTmp({ data: { shop: MARKETS_MAP[shop] } })
                        }}
                        style={{ marginLeft: '10px' }}
                      >
                        Скачать шаблон
                      </Button>
                    </Row>
                    <Row
                      style={{ marginTop: '15px' }}
                    >
                      <Button
                        type={TYPE_BUTTONS.BLUE}
                        onClick={async () => {
                          await MarketOzonApi.updateStocksAndPrices({
                            data: {
                              shop: MARKETS_MAP[shop],
                              filter: {},
                              rules: {
                                skipPriceUpdate: true,
                                fbsActiveUpdate: true
                              },
                              skladName: 'msk',
                              waitEnd: true,
                            }
                          })
                          setUpdate(!update)
                        }}
                      >
                        Отправить остатки
                      </Button>
                      <Button
                        style={{ marginLeft: '30px' }}
                        type={TYPE_BUTTONS.WHITE}
                        onClick={() => {
                          MarketOzonApi.excelStocksFbsActive({ data: { shop: MARKETS_MAP[shop] } })
                        }}
                      >
                        Скачать остатки
                      </Button>
                    </Row>
                  </Column>

                }
                {shop === OZON_2 && isOwner && !isFbsRemainsMode && (
                  <>
                    <CheckButton
                      checked={isExpress}
                      onSelect={() => setIsExpress(!isExpress)}
                      style={{ marginLeft: '10px' }}
                    />
                    <Text style={{ marginLeft: '10px', marginTop: '1px' }}>Показать Express</Text>{' '}
                  </>
                )}
                {/* </Row> */}

                {isOwner && !isFbsRemainsMode && (
                  <>
                    <Row style={{ marginTop: '10px', marginBottom: '10px' }}>
                      <Column style={{ width: '200px' }}>
                        <SendButton
                          sendApi={MarketOzonApi.updateByExcel}
                          sendData={{ data: { shop: MARKETS_MAP[shop] } }}
                        >
                          Подгрузить данные
                        </SendButton>
                        <Link download href={'/ozon.xlsx'} name="Шаблон озон товары" className={styles.link_download}>
                          Скачать шаблон
                        </Link>
                      </Column>
                    </Row>

                    <Row style={{ alignItems: 'flex-end', marginRight: '10px' }}>
                      <Button onClick={loadData} type={TYPE_BUTTONS.WHITE} style={{ marginRight: '10px' }}>
                        Выгрузить контент
                      </Button>
                      <Button onClick={() => loadData(true)} type={TYPE_BUTTONS.WHITE} style={{ marginRight: '10px' }}>
                        Выгрузить новый контент
                      </Button>
                      <Button onClick={() => MarketOzonApi.loadWarehouseStocks({ data: { shop: MARKETS_MAP[shop] } })} type={TYPE_BUTTONS.WHITE}>
                        Выгрузить остатки мп
                      </Button>
                    </Row>
                  </>
                )}
              </Column>
              {isOwner && !isFbsRemainsMode && (
                <Column className={styles.stosks_column}>
                  <Row style={{ alignItems: 'flex-end' }}>
                    <Select
                      label="Поставщик"
                      select={provider}
                      valueFn={(p) => p.name}
                      list={providers}
                      width={'200px'}
                      onSelect={(v) => changeProvider(v)}
                    />
                  </Row>

                  <Row style={{ marginTop: '10px' }}>
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() => updateProviderStocksAndPrice(provider.id)}
                      style={{ marginRight: '10px' }}
                      disabled={true}
                    >
                      Обновить остатки и цены
                    </Button>
                    <Button
                      type={TYPE_BUTTONS.RED}
                      onClick={() => updateProviderStocksAndPrice(provider.id, true)}
                      style={{ marginRight: '10px' }}
                      disabled={true}
                    >
                      Обнулить остатки
                    </Button>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      onClick={() => updateProviderPrice(provider.id)}
                      style={{ marginRight: '10px' }}
                    >
                      Пересчитать цены
                    </Button>
                  </Row>
                  {shop === OZON_2 && isExpress && (
                    <Row style={{ marginTop: '10px' }}>
                      <Button
                        type={TYPE_BUTTONS.GREEN}
                        onClick={() => updateExpressStocks('msk')}
                        style={{ marginRight: '15px', width: '100%' }}
                        disabled={shop !== OZON_2}
                      >
                        Обновить остатки EXPRESS MSK
                      </Button>
                      <Button
                        type={TYPE_BUTTONS.RED}
                        onClick={() => updateExpressStocks('msk', true)}
                        style={{ width: '100%' }}
                        disabled={shop !== OZON_2}
                      >
                        Обнулить остатки EXPRESS MSK
                      </Button>
                    </Row>
                  )}

                  {shop === OZON_2 && isExpress && (
                    <Row style={{ marginTop: '10px' }}>
                      <Button
                        type={TYPE_BUTTONS.GREEN}
                        onClick={() => updateExpressStocks('ekb')}
                        style={{ marginRight: '15px', width: '100%' }}
                        disabled={shop !== OZON_2}
                      >
                        Обновить остатки EXPRESS EKB
                      </Button>
                      <Button
                        type={TYPE_BUTTONS.RED}
                        onClick={() => updateExpressStocks('ekb', true)}
                        style={{ width: '100%' }}
                        disabled={shop !== OZON_2}
                      >
                        Обнулить остатки EXPRESS EKB
                      </Button>
                    </Row>
                  )}

                  <MarketProvidersDateUpdate providerData={providerData} />

                  <Row style={{ marginTop: '10px' }}>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      onClick={() => updateWarehouseStocks()}
                      style={{ marginRight: '10px' }}
                    >
                      Обновить остатки со склада
                    </Button>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      onClick={() => updateWarehouseStocks(true)}
                      style={{ marginRight: '10px' }}
                    >
                      Обнулить остатки со склада
                    </Button>
                  </Row>
                </Column>
              )}

            </Row>

          </WhiteBlock>
          {isFbsRemainsMode && (
            <>
              <WhiteBlock
                style={{ minWidth: '400px' }}
                title="Управление отгрузками FBS" left={true} minimize={true} openBlock={true}
              >
                <div
                  style={{ alignSelf: 'center', width: 'stretch' }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', height: 'stretch', justifyContent: 'space-between' }}>
                    <div style={{ marginTop: '0px', textAlign: 'center', fontWeight: 'bold', color: '#0000009e' }}>Рассчёт цен</div>
                    {/* <div style={{ border: '2px solid #0000006c', padding: '15px', marginTop: '15px', borderRadius: '5px', width: '320px' }}>
                      <Row style={{ justifyContent: 'space-between' }}>
                        <TextGrey>Коеффициент логистики, %</TextGrey>
                        <Input
                          center
                          style={{ width: '60px' }}
                          disabled={!isOwner}
                          value={marketInfo?.commission?.delivery_sort_center?.coef}
                          onBlur={async (v) => {
                            setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'wb', field: 'commission.delivery_sort_center.coef', value: +v } }).then(r => r.marketInfo))
                          }}
                        />
                      </Row>
                      <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                        <TextGrey>Логистика первого литра</TextGrey>
                        <Input
                          center style={{ width: '60px' }}
                          disabled={true}
                          value={marketInfo?.commission?.delivery_sort_center?.first_liter_base}
                        // onBlur={async (v) => {
                        // const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.tariff.delivery.liter', value: v } }).then(r => r.supply)
                        // }}
                        />
                      </Row>
                      <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                        <TextGrey>Логистика последующего литра</TextGrey>
                        <Input
                          center style={{ width: '60px' }}
                          disabled={true}
                          value={marketInfo?.commission?.delivery_sort_center?.step_liter_base}
                        // onBlur={async (v) => {
                        // setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'wb', field: 'commission.delivery_sort_center.step_liter_base', value: +v } }).then(r => r.marketInfo))
                        // }}
                        />
                      </Row>
                    </div> */}
                    <Row style={{ marginTop: '15px', justifyContent: 'space-between' }}>
                      <TextGrey>Маржинальность, %</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={marketInfo?.marginality?.percent}
                        onBlur={async (v) => {
                          setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'ozon', field: 'marginality.percent', value: +v } }).then(r => r.marketInfo))
                        }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Маржинальность мин, руб.</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={marketInfo?.marginality?.rub}
                        onBlur={async (v) => {
                          setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'ozon', field: 'marginality.rub', value: +v } }).then(r => r.marketInfo))
                        }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Повышенная комиссия, %.</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={marketInfo?.commission?.increased_commission?.percent}
                        onBlur={async (v) => {
                          setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'ozon', field: 'commission.increased_commission.percent', value: +v } }).then(r => r.marketInfo))
                        }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Стоимость короба, руб.</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={marketInfo?.common_commission?.box_cost}
                        onBlur={async (v) => {
                          setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'ozon', field: 'common_commission.box_cost', value: +v } }).then(r => r.marketInfo))
                        }}
                      />
                    </Row>
                    <Button
                      type={TYPE_BUTTONS.GREEN}
                      style={{
                        backgroundColor: false ? '#ed6e14d3' : '',
                        marginTop: '20px'
                      }}
                      disabled={!isOwner}
                      onClick={async () => {
                        await MarketOzonApi.updateStocksAndPrices({ data: { shop: MARKETS_MAP[shop], skladName: 'msk', filter: { onlyActiveFbsProducts: true }, rules: { onlyPrices: true }, waitEnd: true } })
                        setUpdate(!update)
                      }}
                    >
                      Пересчитать цены
                    </Button>
                  </div>
                </div>

              </WhiteBlock>
            </>
          )}
        </Row>

        <OzonTable
          parentUpdate={update}
          isExpress={isExpress}
          setIsFbsRemainsMode={setIsFbsRemainsMode}
          isFbsRemainsMode={isFbsRemainsMode}
          updateProviderStocksAndPrice={updateProviderStocksAndPrice}
          updateProviderPrice={updateProviderPrice}
        />
      </Content>
    </>
  );
};

export default OzonPage;
